import {
    APP,
} from '_pixiSrc/globals';
import * as FEATURES from '_pixiSrc/layout/features';
import {
    ALIGN,
} from '_pixiSrc/globals';
import Sprite from '_pixiSrc/display/Sprite';
import Timer from '_pixiSrc/Timer';
import Static from '../libraries/Static';
import DynamicData from './DynamicData';
import GameData from './GameData';
import AudioManager from './AudioManager';
import NeutrinoFX from '../NeutrinoFX';
import GameConfig from '../libraries/GameConfig';

let endTimer = null;

/**
 * @class BigWin
 * AudioManager class manage big win animation
 */
class BigWin extends Sprite {
    /**
   * @name invoke
   * @description compute win type and display win animation
   */
    static invoke(parent, x = 0, y = 0, callback, isExpanding, bet) {
        if (this.isOpen) { return this.mainWindow; }

        this.spine = null;
        this.coins = null;

        this.fxChannel = null;

        this.mainWindow = parent.addChild(new Sprite());
        this.mainWindow.position.set(x, y);

        let sum;

        /**
     * get winning amount and bet amount
     */
        if (isExpanding) {
            sum = DynamicData.getValue('lastExpandingWin');
        } else {
            sum = DynamicData.getValue('lastWin') - DynamicData.getValue('lastExpandingWin');
        }

        /**
     * check win amount
     * bet * 10 <= win amount < bet * 20 then set win type big win
     * bet * 20 <= win amount < bet * 50 then set win type monster win
     * win amount >= bet * 50 then set win type legendary win
     */
        const bigWinsObj = GameConfig.bigWinsObj;
        if (sum >= bigWinsObj.bigWin.minBetMultiplier * bet && sum < bigWinsObj.bigWin.maxBetMultiplier * bet) {
            this.winType = 0;
        } else if (sum >= bigWinsObj.monsterWin.minBetMultiplier * bet && sum < bigWinsObj.monsterWin.maxBetMultiplier * bet) {
            this.winType = 1;
        } else if (sum >= bigWinsObj.legendaryWin.minBetMultiplier * bet && bigWinsObj.legendaryWin.maxBetMultiplier === null) {
            this.winType = 2;
        } else if (sum < bigWinsObj.bigWin.minBetMultiplier * bet) {
            if (callback) {
                callback();
            }
            this.mainWindow.safeRemove();
            return false;
        }

        GameData.setProperty('isPPAllowed', false);

        this.duration = 8000;
        this.timer = null;
        this.isStopped = false;
        this.isOpen = true;

        this.callback = callback;

        /**
     * show big win animation window
     */
        this._showWindow(this.winType, sum);

        return this.mainWindow;
    }

    /**
   * @name _showWindow
   * @description show big win animation
   */
    static _showWindow(type = 0, sum = 0) {
        if (!this.isOpen) { return; }

        /**
     * set sound according win type
     */
        let soundName = 'legendary_win';
        if (type == 0) { soundName = 'big_win'; }
        if (type == 1) { soundName = 'monster_win'; }

        this.fxChannel = AudioManager.playSound('fx', soundName);

        const container = this.mainWindow.addChild(new Sprite());

        let animType;

        switch (this.winType) {
            case 0:
                animType = 'big';
                break;
            case 1:
                animType = 'monster';
                break;
            case 2:
                animType = 'legendary';
                break;
        }

        let bigWinScale = 0.5;
        if (FEATURES.IE || APP.stages[0].renderer instanceof PIXI.CanvasRenderer) {
            bigWinScale = 0.75;
        }
        const bigWinPositionX = (APP.layout.calculatedSize.screenWidth * bigWinScale) - (APP.config.size.width * bigWinScale) - (150 * bigWinScale);
        const bigWinPositionY = (APP.layout.calculatedSize.screenHeight * bigWinScale) - (APP.config.size.height * bigWinScale) + (10 * bigWinScale);
        this.effect = new NeutrinoFX(animType, [bigWinPositionX, bigWinPositionY, 0], null, [bigWinScale, bigWinScale, bigWinScale]);
        this.effect.fx.alpha = 0.5;
        container.addChild(this.effect);

        container.winBox = container.addChild(APP.library.getSprite('main/display'));
        container.winBox.position.set(0, 190);
        container.winBox.scale.set(0);
        container.winBox.scaleTo(0.8, 300);
        container.winBox.zIndex = 1;

        container.winAmount = Static.writeText(container.winBox, sum, 'font_num_new', 0, -10, {
            spaceDivider: true,
        });
        container.winAmount.scale.set(1.2);
        container.winAmount.align = ALIGN.CENTER;

        setTimeout(() => {
            container.winBox.scaleTo(0, 200);
        }, this.duration - 500);

        if (endTimer) { Timer.clear(endTimer); }
        endTimer = new Timer(this.close.bind(this), this.duration);
    }

    /**
   * @name stop
   * @description close big win window
   */
    static stop(callback) {
        if (!this.isOpen) {
            if (callback) { callback(); }
            return false;
        }

        if (callback) { this.callback = callback; }

        this.close();
    }

    /**
   * @name close
   * @description close big win window
   */
    static close() {
        if (!this.isOpen) { return; }

        if (this.fxChannel) { this.fxChannel.stop(); }

        this.isOpen = false;
        this.mainWindow.safeRemove();
        GameData.setProperty('isPPAllowed', true);

        this.effect = null;
        if (endTimer) { Timer.clear(endTimer); }
        endTimer = null;

        if (this.callback) { this.callback(); }

        this.callback = null;
    }
}

export default BigWin;
